import {Record as record} from 'immutable';
import {SundryCodes} from '../../constants/AppConstants';

const defaults = {
    id: null,
    code: null,
    price: null,
    refunded: false,
    name: null,
};

class OrderSundry extends record(defaults) {
    static fromJSON(json) {
        return new OrderSundry({
            id: json.id,
            code: json.code,
            price: json.price,
            refunded: json.refunded,
            name: json.name,
        });
    }

    isBookingFee() {
        return this.code === SundryCodes.BOOKING_FEE;
    }

    /*
        This method was previously only checking for TH discount codes,
        so will always return false for now, unless implemented for another TOC
    */
    isDiscountCode() {
        return false;
    }
}

export default OrderSundry;



// WEBPACK FOOTER //
// ./src/records/order/Sundry.js